<div ngbDropdown container="body" class="d-inline-block w-100">
  <div class="input-group form-floating">
    <input
      type="text"
      id="fileName"
      name="baseFileName"
      [(ngModel)]="baseFileName"
      class="form-control"
      [disabled]="disableFileName"
      [readonly]="disableFileName"
      placeholder="File Name"
      (input)="onFileNameChange()" />
    <!-- <div ngbDropdown class="d-inline-block"> -->
    <label for="fileName" style="z-index: 10">File Name</label>
    <button
      class="btn btn-sm btn-outline-primary"
      [ngClass]="selectedFileType.cssClass"
      id="dropdownFileTypes"
      [disabled]="disableFileType"
      ngbDropdownToggle>
      {{ selectedFileType.extension || 'Select a file type' }}
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownFileTypes">
      <button
        class="dropdown-item"
        [ngClass]="fileType.cssClass"
        *ngFor="let fileType of fileTypes"
        (click)="onFileTypeChange(fileType)">
        {{ fileType.extension }}
      </button>
    </div>
  </div>
</div>
